import React from "react";
import NavbarDoctorOffice from "../NavbarDoctorOffice";
import { Card, CardBody, Col, Input, Label, Row, TabContent } from "reactstrap";
import CardHeaderTabs from "../../../@dhn/components/molecules/card-header-tabs";
import useActions from "./useActions";
import OpenMonths from "./components/OpenMonths";
import ClosedMonths from "./components/ClosedMonths";
import DoctorsOfficePage from "../components/DoctorsOfficePage";
import "./monthly-closing-motion.css";

export default function MonthlyClosing({
  profile,
  user,
  center,
  dataDoctor,
  history,
}) {
  const [{ state }, actions] = useActions();

  const { activeTab } = state;

  const { handleActiveTab } = actions;

  return (
    <div className="animated fadeIn monthly-closing-view-enter">
      <NavbarDoctorOffice
        profile={profile}
        user={user}
        center={center}
        dataDoctor={dataDoctor}
      />

      <DoctorsOfficePage icon="fa-calculator" title="Cierre Mensual" className="monthly-closing-card-enter">
        <Row form>
          <Col md={3}>
            <Label>Centro:</Label>
            <Input value={center} disabled />
          </Col>
          <Col md={4}>
            <Label>Médico</Label>
            <Input disabled value={`${user.firstName} ${user.lastName}`} />
          </Col>
        </Row>

        <Row form className="mt-4">
          <Col>
            <Card>
              <CardHeaderTabs
                active={activeTab}
                onClick={(tab) => handleActiveTab(tab)}
                tabs={[
                  {
                    id: 1,
                    name: "Meses Abiertos",
                  },
                  {
                    id: 2,
                    name: "Meses Cerrados",
                  },
                ]}
              />
              <CardBody>
                <TabContent className="border-0" activeTab={activeTab}>
                  <OpenMonths {...{ history, dataDoctor }} />
                  <ClosedMonths {...{ history, dataDoctor }} />
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </DoctorsOfficePage>
    </div>
  );
}
